<template>
  <div id="nested-form" class="scfForm inxmail">
    <div v-if="!initialDataLoaded">Loading Data</div>
    <template v-if="isInEditingMode && initialDataLoaded">
      <div id="formAdminContainer" class="campusForm">
        <fieldset class="scfSectionBorderAsFieldSet">
          <div class="scfSectionContent">
            <div class="scfMultipleLineTextBorder">
              <label class="scfMultipleLineTextLabel" :for="idHelper.getId('txt-intro-de')">{{
                translationHelper.getTranslation("camp_NewsletterIntroTextDe")
              }}</label>
              <div class="scfMultipleLineGeneralPanel">
                <textarea :id="idHelper.getId('txt-intro-de')" :name="idHelper.getId('txt-intro-de')"
                  v-model="introText.de" />
              </div>
            </div>
            <div class="scfMultipleLineTextBorder">
              <label class="scfMultipleLineTextLabel" :for="idHelper.getId('txt-intro-en')">{{
                translationHelper.getTranslation("camp_NewsletterIntroTextEn")
              }}</label>
              <div class="scfMultipleLineGeneralPanel">
                <textarea :id="idHelper.getId('txt-intro-en')" :name="idHelper.getId('txt-intro-en')"
                  v-model="introText.en" />
              </div>
            </div>
            <div class="scfDropListBorder">
              <label :for="idHelper.getId('ddl-filter')" class="scfDropListLabel" v-once>{{
                translationHelper.getTranslation(
                  "camp_NewsletterAvailableLists"
                )
              }}</label>
              <div class="scfDropListGeneralPanel">
                <select size="10" :id="idHelper.getId('ddl-filter')" :name="idHelper.getId('ddl-filter')"
                  class="select select1" multiple v-model.number="selectedListIds">
                  <option class="multiple-select-option" v-for="list in availableLists" :value="list.id" :key="list.id">
                    {{ getListName(list) }}
                  </option>
                </select>
                <span class="validationMessage" v-if="filterError">{{
                  translationHelper.getTranslation(
                    "camp_NewsletterListRequiredMessage"
                  )
                }}</span>
              </div>
            </div>
          </div>
        </fieldset>
        <div class="scfSubmitButtonBorder">
          <button :id="idHelper.getId('btnSaveConfig')" v-if="!isSubmitting" @click="saveConfig">
            {{
              translationHelper.getTranslation(
                "camp_NewsletterButtonSaveConfig"
              )
            }}
          </button>
          <div v-if="isSavingConfig">
            {{
              translationHelper.getTranslation("camp_NewsletterSavingConfig")
            }}
          </div>
          <div v-if="saveConfigResultText">{{ saveConfigResultText }}</div>
        </div>
      </div>
    </template>
    <template v-else-if="!isInEditingMode && initialDataLoaded">
      <ValidationObserver ref="obs" v-slot="{ validated }">
        <div v-if="resultText" v-html="resultText"></div>
        <div v-if="!resultText" id="formContainer" class="campusForm">
          <fieldset class="scfSectionBorderAsFieldSet">
            <div class="scfSectionContent">
              <span v-if="
                introText &&
                introText[
                aspData.glassItemData.language.substr(0, 2).toLowerCase()
                ]
              " class="intro-info" v-html="introText[
                aspData.glassItemData.language.substr(0, 2).toLowerCase()
              ]
                "></span>
              <div class="scfCheckboxBorder">
                <div class="scfCheckBoxListGeneralPanel topics-wrapper">
                  <h5 class="topics-title">{{ translationHelper.getTranslation("camp_NewsletterTopicsTitle") }}</h5>
                  <ValidationProvider name="topics" rules="required" v-slot="{ errors }">
                    <div class="scfCheckbox" v-for="(configuredList, index) in availableConfiguredLists">
                      <div class="icheckbox_hslu icheck-item top" :class="{ checked: configuredList.isChecked }"
                           @click="toggleList(configuredList.id)">
                        <input class="icheck-input" :checked="configuredList.isChecked"
                          :id="`${idHelper.getId('cbx-newsletter')}-${index}`" :name="idHelper.getId('cbx-newsletter')"
                          v-model="topicsSelected" :value="configuredList.id" type="checkbox" />
                      </div>
                      <label class="icheck-label top" :for="`${idHelper.getId('cbx-newsletter')}-${index}`">
                        {{ getListName(configuredList) }}
                      </label>
                    </div>
                    <div class="validationMessage" v-if="showErrors && errors.length">
                      {{
                        translationHelper.getTranslation(
                          "camp_NewsletterTopicsInvalidMessage"
                        )
                      }}
                    </div>
                  </ValidationProvider>
                </div>
              </div>
              <div class="scfSingleLineTextBorder">
                <label class="scfSingleLineTextLabel" :for="idHelper.getId('txt-email')" v-once>{{
                  translationHelper.getTranslation("camp_EMail") }}</label>
                <div class="scfSingleLineGeneralPanel">
                  <ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
                    <input :id="idHelper.getId('txt-email')" :name="idHelper.getId('txt-email')" type="email" required
                      v-model="member.email" />
                    <div class="validationMessage" v-if="showErrors && errors.length">
                      {{
                        translationHelper.getTranslation(
                          "camp_EMailInvalideMessage"
                        )
                      }}
                    </div>
                  </ValidationProvider>
                </div>
              </div>
              <div class="scfDropListBorder">
                <label :for="idHelper.getId('ddl-gender')" class="scfDropListLabel" v-once>{{
                  translationHelper.getTranslation("camp_Gender") }}</label>
                <div class="scfDropListGeneralPanel">
                  <select :id="idHelper.getId('ddl-gender')" :name="idHelper.getId('ddl-gender')" class="select select1"
                    v-model.number="member.gender">
                    <option v-for="gender in availableGenders" :value="gender.value" :key="gender.value">
                      {{ gender.text }}
                    </option>
                  </select>
                  <div class="validationMessage" v-if="showErrors && genderError">
                    {{
                      translationHelper.getTranslation(
                        "camp_GenderRequiredMessage"
                      )
                    }}
                  </div>
                </div>
              </div>
              <div class="scfSingleLineTextBorder">
                <label :for="idHelper.getId('txt-firstname')" class="scfSingleLineTextLabel" v-once>
                  {{
                    translationHelper.getTranslation("camp_FirstName")
                  }}
                </label>
                <div class="scfSingleLineGeneralPanel">
                  <ValidationProvider name="firstname" rules="required|alpha_extended|min:2" v-slot="{ errors }">
                    <input :id="idHelper.getId('txt-firstname')" :name="idHelper.getId('txt-firstname')" type="text"
                      v-model.trim="member.firstname" />
                    <div class="validationMessage" v-if="showErrors && errors.length">
                      {{
                        translationHelper.getTranslation(
                          "camp_FirstNameInvalidMessage"
                        )
                      }}
                    </div>
                  </ValidationProvider>
                </div>
              </div>
              <div class="scfSingleLineTextBorder">
                <label :for="idHelper.getId('txt-lastname')" class="scfSingleLineTextLabel" v-once>
                  {{
                    translationHelper.getTranslation("camp_LastName")
                  }}
                </label>
                <div class="scfSingleLineGeneralPanel">
                  <ValidationProvider name="lastname" rules="required|alpha_extended|min:2" v-slot="{ errors }">
                    <input :id="idHelper.getId('txt-lastname')" :name="idHelper.getId('txt-lastname')" type="text"
                      v-model.trim="member.lastname" />
                    <div class="validationMessage" v-if="showErrors && errors.length">
                      {{
                        translationHelper.getTranslation(
                          "camp_LastNameInvalidMessage"
                        )
                      }}
                    </div>
                  </ValidationProvider>
                </div>
              </div>
              <div class="scfCheckboxBorder">
                <div class="scfCheckBoxListGeneralPanel">
                  <span class="scfCheckbox">
                    <ValidationProvider name="Consent" :rules="{ required: { allowFalse: false } }" v-slot="{ errors }">
                      <div class="icheckbox_hslu icheck-item top" :class="{ checked: consentAccepted }"
                        @click="toggleConsent">
                        <input class="icheck-input" :id="idHelper.getId('cbx-click-consent')"
                          :name="idHelper.getId('cbx-click-consent')" type="checkbox" v-model="consentAccepted" />
                      </div>

                      <label class="icheck-label top" :for="idHelper.getId('cbx-click-consent')"
                        v-html="consentTextWithLink()"></label>

                      <div class="validationMessage" v-if="showErrors && errors.length">{{
                        translationHelper.getTranslation("camp_ConsentInvalidMessage") }}</div>
                    </ValidationProvider>
                  </span>
                </div>
              </div>
            </div>
          </fieldset>
          <div class="scfSubmitButtonBorder">
            <button :id="idHelper.getId('btnSubmit')" v-if="!isSubmitting" @click.prevent="submitData">
              {{
                translationHelper.getTranslation(
                  "camp_NewsletterButtonSubscribe"
                )
              }}
            </button>
            <div v-if="isSubmitting">
              {{ translationHelper.getTranslation("camp_UpdatingSaving") }}
            </div>
          </div>
        </div>
      </ValidationObserver>
    </template>
  </div>
</template>
<script>
import { UniqueIdHelper } from "../../../../_Base/Utils";
import { TranslationHelper } from "../../../../_Base/Utils";
import { initEasyDropDown } from "../../../../_Base/Utils.js";
import Newsletter from "../../../../_Api/Newsletter";
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { required, email, min } from "vee-validate/dist/rules";

extend("email", email);
extend("required", required);
extend("min", min);

export default {
  props: ["aspData"],
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      resultText: "",
      genderError: false,
      filterError: false,
      availableGenders: [],
      topicsSelected: [],
      availableLists: [],
      listsLoaded: false,
      selectedListIds: [],
      availableConfiguredLists: [],
      introText: {
        de: "",
        en: "",
      },
      member: {
        email: "",
        gender: 0,
        firstname: "",
        lastname: "",
      },
      consentAccepted: false,
      consentUrl: "",
      showErrors: false,
      isSubmitting: false,
      idHelper: null,
      translationHelper: {},
      isInEditingMode: false,
      hsluNewsletter: null,
      initialDataTasks: [],
      initialDataLoaded: false,
      isSavingConfig: false,
      saveConfigResultText: ""
    };
  },
  created() {
    this.isInEditingMode = this.aspData.glassItemData.isEditing;
    this.idHelper = new UniqueIdHelper(this.aspData.glassItemData.id);
    this.translationHelper = new TranslationHelper(
      this.aspData.initialTranslations
    );
    if (!this.isInEditingMode) {
      this.initialDataTasks.push(this.loadAvailableGenders());
    }
    this.initialDataTasks.push(this.loadHsluNewsletter());
    this.initialDataTasks.push(this.loadAllNewsletters());
    this.initialDataTasks.push(this.getConfigurations());

    this.consentUrl = this.aspData.consentUrl;

    Promise.all(this.initialDataTasks).then(() => {
      this.initialDataLoaded = true;
      let hsluNewsletter = {
        isChecked: false,
        id: this.hsluNewsletter.id,
        name: this.hsluNewsletter.name,
        description: this.hsluNewsletter.description,
      };
      this.availableConfiguredLists.unshift(hsluNewsletter);
      if (this.isInEditingMode) {
        if (!this.selectedListIds.length == 0) {
          this.selectedListIds.push(this.availableLists[0].id);
        }
      } else {
        this.$nextTick(() =>
          initEasyDropDown(this.idHelper.getId("ddl-gender"), (selected) => {
            this.member.gender = parseInt(selected.value);
            this.genderError = this.member.gender === 0;
          })
        );
      }
    });
  },
  mounted() { },

  methods: {
      consentTextWithLink() {
      const lang = this.aspData.glassItemData.language.substr(0, 2).toLowerCase()
      const textToFind = (lang === "en" ? "HSLU's privacy policy" : "Datenschutzerklärung der HSLU");

      let consentText = this.translationHelper.getTranslation('camp_NewsletterConsentText');

      if (consentText?.indexOf(textToFind) !== -1 && this.consentUrl.length > 0) {
        let link = document.createElement("a");
        link.href = this.consentUrl;
        link.textContent = textToFind;
        link.target = "_blank";
        link.style = "text-decoration:underline";
        consentText = consentText.replace(textToFind, link.outerHTML)
      }

      return consentText;
    },
    getListName(list) {
      if (list.description) {
        return Array.from(
          list.description.matchAll(/Newsletter:#(.*)#/gi),
          (m) => m[1]
        )[0];
      } else {
        let listName = list.name;
        let lastIndexOfUderline = listName.lastIndexOf("_");
        var trimmedName = listName.substring(lastIndexOfUderline + 1);
        trimmedName = trimmedName.replace(/-/g, " ");
        return trimmedName;
      }
    },
    getConfigurations() {
      return Newsletter.getConfigurations(
        this.aspData.glassItemData,
        (data) => {
          if (
            data == null ||
            data.selectedLists == null ||
            data.selectedLists.length == 0
          ) {
            this.resultText = "No configuration found";
          } else {
            this.readConfigData(data);
          }
        },
        this.fetchApiFailure
      );
    },
    readConfigData(configData) {
      if (this.listsLoaded) {
        this.introText = configData.introText;
        configData.selectedLists.forEach((list) => {
          var newsletter = this.availableLists.find((x) => x.id === list.id);
          if (newsletter) {
            this.availableConfiguredLists.push({
              isChecked: false,
              id: newsletter.id,
              name: newsletter.name,
              description: newsletter.description,
            });
            this.selectedListIds.push(newsletter.id);
          }
        });
      } else {
        setTimeout(() => this.readConfigData(configData), 300);
      }
    },
    loadHsluNewsletter() {
      return Newsletter.getHsluNewsletter(
        null,
        (data) => (this.hsluNewsletter = data),
        this.fetchApiFailure
      );
    },
    loadAllNewsletters() {
      return Newsletter.getAllNewsletters(
        null,
        (data) => {
          (this.availableLists = data), (this.listsLoaded = true);
        },
        this.fetchApiFailure
      );
    },
    loadAvailableGenders() {
      return new Promise((resolve, reject) => {
        try {
          this.availableGenders = [
            {
              value: 0,
              text: this.translationHelper.getTranslation("camp_GenderChoose"),
            },
            {
              value: 1,
              text: this.translationHelper.getTranslation("camp_GenderMale"),
            },
            {
              value: 2,
              text: this.translationHelper.getTranslation("camp_GenderFemale"),
            },
            {
              value: 3,
              text: this.translationHelper.getTranslation("camp_GenderOther"),
            },
          ];
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    },
    toggleList(id) {         
      let list = this.availableConfiguredLists.find((x) => x.id == id);
      list.isChecked = !list.isChecked;
      this.topicsSelected = this.availableConfiguredLists.filter(l => !!l.isChecked).map(l => l.id)
    },
    toggleConsent() {
      this.consentAccepted = !this.consentAccepted;
    },
    saveConfig() {
      this.isSavingConfig = true;
      var configurationData = {
        selectedListIds: this.selectedListIds,
        introText: this.introText,
        glassItemData: this.aspData.glassItemData,
      };
      Newsletter.saveConfigurations(
        configurationData,
        () => {
          this.isSavingConfig = false;
          this.saveConfigResultText = this.translationHelper.getTranslation(
            "camp_NewsletterConfigurationSaved"
          );
        },
        (status, statusText) => {
          this.isSavingConfig = false;
          this.saveConfigResultText = this.translationHelper.getTranslation(
            "camp_NewsletterConfigurationSaveError"
          );
          this.fetchApiFailure(status, statusText);
        }
      );
    },
    async submitData() {
      this.genderError = this.member.gender === 0;
      this.showErrors = true;
      const isValid = await this.$refs.obs.validate();

      if (isValid && !this.genderError) {
        this.isSubmitting = true;
        var regParams = {
          selectedListIds: this.availableConfiguredLists
            .filter((x) => x.isChecked)
            .map((x) => x.id),
          userInfo: this.member,
        };
        Newsletter.registerToLists(
          regParams,
          this.registerToListsSuccess,
          (status, statusText) => {
            this.isSubmitting = false;
            this.fetchApiFailure(status, statusText);
          }
        );
      }
    },
    registerToListsSuccess(data) {
      if (data != null) {
        this.resultText = this.translationHelper.getTranslation(
          "camp_NewsletterSubscribed"
        );
      }
    },
    fetchApiFailure(status, statusText) {
      this.resultText = "";
    },
  },
};
</script>
<style>
.inxmail .icheck-label {
  max-width: calc(100% - 30px);
}

.inxmail .topics-title {
  padding-bottom: 3px;
  margin-bottom: 0.2em;
}

.inxmail .topics-wrapper {
  width: 100%;
}

.inxmail .scfDropListGeneralPanel {
  margin-bottom: 0;
}

.inxmail .scfCheckBoxListGeneralPanel {
  padding-top: 3px;
}
</style>
